export default __webpack_public_path__ + "085185dbe20d2058df157c8ebbe4deae.png";